export interface Result {
    /**
     * 编号
     * 
     * @type {string}
     */
    id: string;
    /**
     * 名称
     * 
     * @type {string}
     */
    name: string,
    /**
     * 已选择路径项
     * 
     * @type {any[]}
     */
    paths: any[]
}
